var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    { staticClass: "user-selector" },
    [
      _c(
        "Box",
        { staticClass: "inner" },
        [
          _c(
            "Box",
            { attrs: { tag: "header" } },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v("Select user to emulate")
              ]),
              _c(
                "Box",
                {
                  staticClass: "close",
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_c("Icon", { attrs: { name: "times" } })],
                1
              )
            ],
            1
          ),
          _c(
            "ul",
            [
              _vm._l(_vm.users, function(user) {
                return _c(
                  "li",
                  {
                    key: user.id,
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.emulate(user.id)
                      }
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(user.name))])]
                )
              }),
              _c(
                "li",
                {
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.emulate(null)
                    }
                  }
                },
                [_c("span", [_vm._v("No emulation")])]
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }